import TemplateModel from '../../../models/Maintenance/Survey/TemplateModel';
import BaseStore from '../../BaseStore';

export default class TemplateStore extends BaseStore {
  constructor(transportLayer) {
    super(TemplateModel, transportLayer);
  }
};


// WEBPACK FOOTER //
// ./src/stores/Maintenance/Survey/TemplateStore.js